<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-8 mb-6 px-4">

        <h2 class="text-2xl sm:text-3xl font-semibold mb-10" v-html="dataLocales.any_content.title">

        </h2>
        <div class="grid grid-cols-12 lg:gap-8">
            <div class="lg:col-span-7 col-span-12">
                <div class="mb-6" v-for="post in dataLocales.data">
                    <div class="text-base lg:text-lg" v-html="post.description">

                    </div>
                </div>
                <div class="mt-4 text-lg" v-html="dataLocales.any_content.note">

                </div>
                <div class="mt-4">
                    <a href="https://app.qrgateway.com/page-builder" target="_blank" rel="nofollow"
                        class="flex items-center gap-2 h-[50px] px-8 w-fit rounded-3xl bg-success text-white drop-shadow-md hover:drop-shadow-xl">{{
                            $t('try_page_editor') }}</a>
                </div>
            </div>
            <div class="lg:col-span-5 lg:block hidden">
                <nuxt-img loading="lazy" src="/map.png" height="420px" alt="google-map-to-qrcode" format="webp" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import MultiDataLocale from '~~/config/interface/MultiDataLocale';


const dataLocales = new MultiDataLocale([
    {
        locale: "en",
        title: "📸 <span class='text-success'>The Advantages</span> of Using QR Codes for Maps",
        note: "<p> Overall, using QR codes for maps is a convenient and time-saving method for sharing map locations. </p>",
        data: [
            {
                description: " <p> QR codes have become a ubiquitous technology in mobile applications, including mapping applications. </p> <p>Using QR codes to share map locations has several advantages over traditional methods.</p>"
            },
            {
                description: " <p> By scanning a QR code with a mobile phone, users can access map locations directly without typing the address or searching on the map. This saves time and reduces the chances of input errors </p> <p>QR codes make it easier and faster to share map locations, especially when sharing with multiple recipients simultaneously.</p>"
            },
        ]
    },
    {
        locale: "vi",
        title: "📸 <span class='text-success'>Lợi ích</span> của việc sử dụng mã QR cho bản đồ",
        note: "<p> Nhìn chung, việc sử dụng mã QR cho bản đồ là một phương pháp tiện lợi và tiết kiệm thời gian để chia sẻ vị trí bản đồ. </p>",
        data: [
            {
                description: "<p> Mã QR đã trở thành một công nghệ phổ biến trong các ứng dụng di động, bao gồm các ứng dụng bản đồ. </p> <p> Sử dụng mã QR để chia sẻ vị trí bản đồ có một số lợi thế hơn các phương pháp truyền thống.</p>"
            },
            {
                description: "<p> Bằng cách quét mã QR bằng điện thoại di động, người dùng có thể truy cập trực tiếp vào vị trí bản đồ mà không cần nhập địa chỉ hoặc tìm kiếm trên bản đồ. Điều này tiết kiệm thời gian và giảm thiểu khả năng nhập sai thông tin </p> <p> Mã QR giúp dễ dàng và nhanh chóng chia sẻ vị trí bản đồ, đặc biệt là khi chia sẻ với nhiều người nhận cùng một lúc.</p>"
            },
        ]
    },
    {
        locale: "de",
        title: "📸 <span class='text-success'>Die Vorteile</span> von QR-Codes für Karten",
        note: "<p> QR-Codes sind eine bequeme und zeitsparende Methode zum Teilen von Kartenstandorten. </p>",
        data: [
            {
                description: " <p> QR-Codes sind eine weit verbreitete Technologie in mobilen Anwendungen, einschließlich Kartierungsanwendungen. </p> <p> Die Verwendung von QR-Codes zum Teilen von Kartenstandorten hat mehrere Vorteile gegenüber herkömmlichen Methoden.</p>"
            },
            {
                description: " <p> Durch Scannen eines QR-Codes mit einem Mobiltelefon können Benutzer auf Kartenstandorte direkt zugreifen, ohne die Adresse einzugeben oder auf der Karte zu suchen. Dies spart Zeit und reduziert die Chancen auf Eingabefehler </p> <p> QR-Codes erleichtern und beschleunigen das Teilen von Kartenstandorten, insbesondere beim gleichzeitigen Teilen mit mehreren Empfängern.</p>"
            },
        ]
    },
    {
        "locale": "fr",
        "title": "📸 <span class='text-success'>Les avantages</span> d'utiliser des codes QR pour les cartes",
        "note": "<p> Globalement, l'utilisation de codes QR pour les cartes est une méthode pratique et économique pour partager les emplacements de cartes. </p>",
        "data": [
            {
                "description": "<p> Les codes QR sont devenus une technologie omniprésente dans les applications mobiles, y compris les applications de cartographie. </p> <p> L'utilisation de codes QR pour partager les emplacements de cartes présente plusieurs avantages par rapport aux méthodes traditionnelles.</p>"
            },
            {
                "description": "<p> En scannant un code QR avec un téléphone portable, les utilisateurs peuvent accéder directement aux emplacements de cartes sans avoir à taper l'adresse ou à rechercher sur la carte. Cela permet de gagner du temps et réduit les risques d'erreurs de saisie </p> <p> Les codes QR rendent plus facile et plus rapide le partage des emplacements de cartes, en particulier lorsqu'il est nécessaire de les partager avec plusieurs destinataires simultanément. </p>"
            }
        ]
    },
    {
        locale: "es",
        title: "📸 <span class='text-success'>Ventajas</span> de usar códigos QR para mapas",
        note: "<p>En general, el uso de códigos QR para mapas es un método conveniente y que ahorra tiempo para compartir ubicaciones en el mapa.</p>",
        data: [
            {
                description: "<p>Los códigos QR se han convertido en una tecnología omnipresente en aplicaciones móviles, incluidas las aplicaciones de mapas.</p> <p>El uso de códigos QR para compartir ubicaciones en el mapa tiene varias ventajas sobre los métodos tradicionales.</p>"
            },
            {
                description: "<p>Al escanear un código QR con un teléfono móvil, los usuarios pueden acceder a ubicaciones en el mapa directamente sin escribir la dirección o buscar en el mapa. Esto ahorra tiempo y reduce las posibilidades de errores de entrada.</p> <p>Los códigos QR hacen que sea más fácil y rápido compartir ubicaciones en el mapa, especialmente cuando se comparten con múltiples destinatarios simultáneamente.</p>"
            },
        ]
    },
    {
        locale: "it",
        title: "📸 <span class='text-success'>I vantaggi</span> dell'uso dei codici QR per le mappe",
        note: "<p>In generale, l'uso dei codici QR per le mappe è un metodo conveniente e che risparmia tempo per la condivisione delle posizioni sulla mappa.</p>",
        data: [
            {
                description: "<p>I codici QR sono diventati una tecnologia onnipresente nelle applicazioni mobili, incluse le applicazioni di mappatura.</p> <p>L'uso dei codici QR per la condivisione delle posizioni sulla mappa ha diversi vantaggi rispetto ai metodi tradizionali.</p>"
            },
            {
                description: "<p>Scansionando un codice QR con un telefono cellulare, gli utenti possono accedere direttamente alle posizioni sulla mappa senza digitare l'indirizzo o cercarlo sulla mappa. Ciò risparmia tempo e riduce le possibilità di errori di inserimento.</p> <p>I codici QR rendono più facile e veloce la condivisione delle posizioni sulla mappa, specialmente quando si condividono con più destinatari contemporaneamente.</p>"
            },
        ]
    },
    {
        locale: "nl",
        title: "📸 <span class='text-success'>De voordelen</span> van het gebruik van QR-codes voor kaarten",
        note: "<p> Over het algemeen is het gebruik van QR-codes voor kaarten een handige en tijdbesparende methode om locaties op de kaart te delen. </p>",
        data: [
            {
                description: "<p> QR-codes zijn een alomtegenwoordige technologie geworden in mobiele toepassingen, inclusief kaarttoepassingen. </p> <p> Het gebruik van QR-codes om locaties op de kaart te delen, heeft verschillende voordelen ten opzichte van traditionele methoden. </p>"
            },
            {
                description: "<p> Door het scannen van een QR-code met een mobiele telefoon hebben gebruikers direct toegang tot kaartlocaties zonder het adres te hoeven typen of op de kaart te zoeken. Dit bespaart tijd en vermindert de kans op invoerfouten. </p> <p>QR-codes maken het gemakkelijker en sneller om kaartlocaties te delen, vooral bij het delen met meerdere ontvangers tegelijk. </p>"
            },
        ]
    },
    {
        locale: "pt",
        title: "📸 <span class='text-success'>As vantagens</span> do uso de códigos QR para mapas",
        note: "<p> Em geral, o uso de códigos QR para mapas é um método conveniente e econômico para compartilhar localizações no mapa. </p>",
        data: [
            {
                description: "<p> Os códigos QR se tornaram uma tecnologia ubíqua em aplicativos móveis, incluindo aplicativos de mapas. </p> <p> Usar códigos QR para compartilhar localizações no mapa tem várias vantagens em relação aos métodos tradicionais. </p>"
            },
            {
                description: "<p> Ao escanear um código QR com um telefone celular, os usuários podem acessar as localizações do mapa diretamente sem precisar digitar o endereço ou procurar no mapa. Isso economiza tempo e reduz as chances de erros de entrada. </p> <p>Os códigos QR tornam mais fácil e rápido compartilhar localizações no mapa, especialmente ao compartilhar com vários destinatários ao mesmo tempo. </p>"
            },
        ]
    },
    {
        locale: "ja",
        title: "📸 <span class='text-success'>QRコード</span>を使った地図の利点",
        note: "<p>全体的に、QRコードを使った地図は、地図の位置を共有するための便利で時間の節約になる方法です。</p>",
        data: [
            {
                description: "<p>QRコードは、マップアプリケーションを含むモバイルアプリケーションで普及している技術になりました。</p><p>QRコードを使用して地図の位置を共有することには、従来の方法よりもいくつかの利点があります。</p>"
            },
            {
                description: "<p>携帯電話でQRコードをスキャンすることで、ユーザーは住所を入力することなく直接地図の位置にアクセスできます。これにより、時間が節約され、入力エラーの可能性が低くなります。</p><p>QRコードを使うことで、複数の受信者と同時に地図の位置を共有することが簡単で迅速になります。</p>"
            },
        ]
    }
    , {
        locale: "zh",
        title: "📸 <span class='text-success'>使用QR码</span>的地图优势",
        note: "<p>总的来说，使用QR码分享地图位置是一种方便、节省时间的方法。</p>",
        data: [
            {
                description: "<p>QR码已经成为移动应用程序中广泛应用的技术，包括地图应用程序。</p><p>使用QR码分享地图位置比传统方法具有多个优点。</p>"
            },
            {
                description: "<p>通过使用手机扫描QR码，用户可以直接访问地图位置，无需输入地址或在地图上搜索。这样可以节省时间，减少输入错误的机会。</p><p>使用QR码可以更轻松、更快速地分享地图位置，特别是在同时分享给多个接收者的情况下。</p>"
            },
        ]
    }


])

</script>